import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedPrice } from "../FormattedPrice";
import { I18n } from "../I18n";
export const HoverLimitMessage = ({ productLimit = 0, productLimitCurrency }) => {
    return (_jsx("p", { children: _jsx(I18n, { t: "com.communication.text_message.friendly_warning", children: _jsx(FormattedPrice, { value: productLimit, currency: productLimitCurrency }) }) }));
};
//# sourceMappingURL=HoverLimitMessage.js.map